// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"mermaid"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M16 17.5H21V21.0002H16V17.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 17.5H8V21.0002H3V17.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M16 6.50016H21V3H16V6.50016Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 6.50016H8V3H3V6.50016Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M9.50006 13.5002H14.5001V10H9.50006V13.5002Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.5 17.5V12H9.50006M18.5 17.5V12H14.5001M5.5 6.50016V13.5003M18.5 6.50016V13.5003M16 17.5H21V21.0002H16V17.5ZM3 17.5H8V21.0002H3V17.5ZM16 6.50016H21V3H16V6.50016ZM3 6.50016H8V3H3V6.50016ZM9.50006 13.5002H14.5001V10H9.50006V13.5002Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-mermaid')
export default class MermaidIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mermaid',
    }
  }
}
